import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/news/news/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/news/news/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/news/news/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/news/news/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/news/news/detail',
    method: 'get',
    params: { id }
  })
}
export function putStatus(data) {
  return request({
    url: '/news/news/update',
    method: 'post',
    data
  })
}

/** 消息通知自动翻译（按字典 cooking_translate_lang） */
export function autoTranslate(data) {
  return request({
    url: '/news/news/auto-translate',
    method: 'post',
    data
  })
}
